import {alpha, Box} from '@mui/material';
import type {ReactNode} from 'react';
import React from 'react';

export function ModalContextBar({left, right}: { left?: ReactNode; right?: ReactNode }) {
    return (
        <Box
            sx={{
                px: 2.75,
                py: 1.1,
                // dezenter Rot-Tint (~#FFEBEE), nicht das kräftige error.light
                bgcolor: (theme) => alpha(theme.palette.error.main, 0.08),
                borderTop: 1,
                borderBottom: 1,
                borderColor: 'rgba(229,57,53,.18)',
                display: 'flex',
                alignItems: 'center',
                gap: 1.25,
                fontSize: 13,
            }}
        >
            <Box sx={{display: 'flex', alignItems: 'center', gap: 1}}>{left}</Box>
            <Box sx={{ml: 'auto', color: 'text.secondary', fontSize: 12.5}}>{right}</Box>
        </Box>
    );
}